export default {
  locale: "es",
  name: "Ventana de Cierre de Viaje",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Fecha inicio",
      },
      {
        fieldName: "endDate",
        displayName: "Fecha fin",
      },
    ],
    form: [
      {
        fieldName: "restrictions",
        widget: "closeTravel",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Introducir fecha",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
};
